import { Base64Tool } from './components/Base64Tool';
import { CustomClaimsChecker } from './components/CustomClaimsChecker';
import { DiffTool } from './components/DiffTool';
import { RuleOfThreeTool } from './components/RuleOfThreeTool';
import { WordCharacterCounter } from './components/WordCharacterCounter';

export const Tools = () => {
    return (
        <div className="max-w-6xl mx-auto p-4 sm:p-6">
            <div className="mb-8">
                <h1 className="text-3xl font-bold text-gray-900 mb-2">Tools</h1>
            </div>

            <div className="flex flex-col gap-6">
                <CustomClaimsChecker />
                <WordCharacterCounter />
                <DiffTool />
                <RuleOfThreeTool />
                <Base64Tool />
            </div>
        </div>
    );
};
